module.exports = __webpack_public_path__ + "assets/apple_store_logo.e766d30f.svg";